export enum DroppableId {
  Visible = "visible",
  Hidden = "hidden",
}
